import request from '../../helpers/requests';
import toast, { Toaster } from 'react-hot-toast';


const CartManager = {
    getCartData: async function () {
        let returnVal = {
            cartId: this.getCartId(),
            cartCount: this.getCartCount(),
            cartPrice: await this.getCartPrice(),
            cartItems: await this.getCartItemsFull()
        }
        console.log('GetCartData');
        return returnVal;
    },

    getCartItemsFull: async function () {
        const allProducts = await request.getProducts([],1,1000000,"none").then((products) => {
            console.log('GetCartItemsFull')

            if(products.success) {
                return products.data.containers;
            }
            else {
                toast.error("There was a critical error retrieving products", {position: 'bottom-right'});
            }
        })

        const cartItems = await this.getCartItems();

        let newCartItems = [];

        cartItems.forEach((item) => {
            allProducts.forEach((product) => {
                if(item.product_id == product.container_id) {
                    newCartItems.push({...item, ...product});
                }
            })
        })
        
        return newCartItems;
    },

    getCartId: function () {
        return localStorage.getItem('cart');
    },

    getCartPrice: async function () {
        return await request.getCartPrice(this.getCartId()).then((price) => {
            if(price.success) {
                return price.data;
            }
            else {}
        })
    },

    getCartCount: function () {
        request.getCartCount(this.getCartId()).then((count) => {
            if(count.success) {
                localStorage.setItem("cartCount", count.data);
            }
            else {}
        })
        return localStorage.getItem('cartCount');
    },

    getCartItems: async function () {
        return request.getCartItems(this.getCartId()).then((cart) => {
            if(cart.success) {
                return cart.data;
            }
            else {}
        })
    },

    removeFromCart: async function (product_id, quantity) {
        const returnVal = await request.removeFromCart(await this.getCartId(), product_id, quantity).then((remove) => {
            if(remove.success) {
                toast.success("Item removed from the cart", {position: 'bottom-right'});
                this.getCartCount();
                return this.getCartItems()
            }
            else {
                toast.error("Item could not be removed from the cart", {position: 'bottom-right'});
            }
        })
        window.dispatchEvent(new Event('storage'));
        return returnVal;
    },

    add: async function (product) {
        return await request.addToCart(product).then((cart) => {
            if(cart.success) {
                toast.success("Item added to the cart", {position: 'bottom-right'});
                if (localStorage.getItem('cart') === null) {
                    localStorage.setItem("cartCount", parseInt(product.quantity));
                    localStorage.setItem('cart', cart.data);
                }else {
                    localStorage.setItem("cartCount", parseInt(localStorage.getItem('cartCount')) + parseInt(product.quantity));
                }
                window.dispatchEvent(new Event('storage'));
                return true
            }
            else {
                toast.error("Item could not be added to the cart: " + cart.data, {position: 'bottom-right'});
                return true
            }
        })
    },
    
    remove: function (pid) {
        let cart = this.get();
        if (cart === null) {
            return;
        }
        let index = cart.indexOf(pid);
        if (index > -1) {
            cart.splice(index, 1);
        }
        localStorage.setItem('cart', JSON.stringify(cart));
        window.dispatchEvent(new Event('storage'));
    },

    clearCart: function () {
        request.clearCart(this.getCartId());
        localStorage.removeItem('cart');
        localStorage.removeItem('cartCount');
        window.dispatchEvent(new Event('storage'));
        toast.success("Cleared the cart", {position: 'bottom-right'});
    },

    clearAddToCart: function (props) {
        this.clearCart();
        this.add(props);
    },
    
    total: function () {
        let cart = this.get();
        if (cart === null) {
            return 0;
        }
        let total = 0;
        cart.forEach(product => {
            total += product.price;
        });
        return total;
    },
    
    count: function () {
        let cart = this.get();
        if (cart === null) {
            return 0;
        }
        return cart.length;
    },
    
    isInCart: async (pid) => {
        return CartManager.getCartItems().then((cart) => {
            if (cart === null) {
                return false;
            }
            const cartMap = cart.map(data => parseInt(data.product_id));
            return cartMap.includes(parseInt(pid));
        });
    }

}

export default CartManager;